import { BrowserModule } from '@angular/platform-browser';
import { HttpModule,BrowserXhr } from '@angular/http';
import { NgModule } from '@angular/core';
import { routes } from './app.router';
import { APP_BASE_HREF  } from '@angular/common';
import { FormsModule,ReactiveFormsModule  } from '@angular/forms';
import { SimpleGlobal } from 'ng2-simple-global';
import { NgxPaginationModule } from 'ngx-pagination';

import { AppComponent } from './app.component';
import { CircularComponent } from './_components/circular/circular.component';
import { SearchComponent } from './_components/search/search.component';
import { ServiceprovidertypesComponent } from './_components/serviceprovidertypes/serviceprovidertypes.component';
import { AboutComponent } from './_components/about/about.component';
import { ServicesComponent } from './_components/services/services.component';
import { SharedComponent } from './_components/shared/shared.component';
import { MenuComponent } from './_components/menu/menu.component';
import { HeaderComponent } from './_components/header/header.component';
import { FooterComponent } from './_components/footer/footer.component';
import { DashboardComponent } from './_components/dashboard/dashboard.component';
import { BrandsComponent } from './_components/brands/brands.component';
import { LocationsComponent } from './_components/locations/locations.component';
import { LoginComponent } from './_components/login/login.component';
import { LoginService } from './_services/login.service';
import { LogoutComponent } from './_components/logout/logout.component';
import { AddBrandsComponent } from './_components/brands/add-brands/add-brands.component';
import { AddLocationsComponent } from './_components/locations/add-locations/add-locations.component';
import { TjComponent } from './_components/tj/tj.component';
import { StringFilterPipe } from './-pipe/string-filter/string-filter.pipe';
import { LocationeditComponent } from './_components/locations/locationedit/locationedit.component';
import { OrderrByPipe } from './-pipe/orderby/orderby.pipe';
import { DropfilterPipe } from './-pipe/drop_filter/drop_filter.pipe';
import { TrimPipe } from './-pipe/trim.pipe';
import { DropfilterBrand } from './-pipe/drop_filter/drop_filter_brand.pipe';
import { StringFilterPipeBrands } from './-pipe/string-filter/string-filter-brands.pipe';
import { EditBrandsComponent } from './_components/brands/edit-brands/edit-brands.component';
import { EditserviceprovidertypeComponent } from './_components/serviceprovidertypes/editserviceprovidertype/editserviceprovidertype.component'
import { LowerCasePipe,TitleCasePipe,UpperCasePipe } from './-pipe/caseconversion.pipe';
import { ImageprocessComponent } from './_components/imageprocess/imageprocess.component';

import {CustExtBrowserXhr} from './cust-ext-browser-xhr';
import { RouteLocationComponent } from './_components/locations/route-location/route-location.component';
import { AddServiceprovidertypeComponent } from './_components/serviceprovidertypes/add-serviceprovidertype/add-serviceprovidertype.component';

@NgModule({
  declarations: [
    AppComponent,
    CircularComponent,
    SearchComponent,
    ServiceprovidertypesComponent,
    AboutComponent,
    ServicesComponent,
    SharedComponent,
    MenuComponent,
    HeaderComponent,
    FooterComponent,
    DashboardComponent,
    BrandsComponent,
    LocationsComponent,
    LoginComponent,
    LogoutComponent,
    AddBrandsComponent,
    AddLocationsComponent,
    TjComponent,
    StringFilterPipe,
    LocationeditComponent,
    OrderrByPipe,
    DropfilterPipe,
    TrimPipe,
    DropfilterBrand,
    StringFilterPipeBrands,
    EditBrandsComponent,
    EditserviceprovidertypeComponent,
    LowerCasePipe,TitleCasePipe,UpperCasePipe, ImageprocessComponent, RouteLocationComponent, AddServiceprovidertypeComponent
  ],
  imports: [
    BrowserModule,
    HttpModule,
    routes,
    FormsModule,
    ReactiveFormsModule,
    NgxPaginationModule
  ],
   providers: [
    { provide: APP_BASE_HREF, useValue: '/'},
    SimpleGlobal,
    StringFilterPipe,
    OrderrByPipe,
    DropfilterPipe,
    TrimPipe,
    LowerCasePipe,TitleCasePipe,UpperCasePipe
  ],
  bootstrap: [AppComponent],
  entryComponents: []
})

export class AppModule { }



// WEBPACK FOOTER //
// C:/wamp64/www/duetz.repos/angular4/src/app/app.module.ts